import React from "react";

import { Skeleton } from "@mui/material";

const SearchResultSkeletonCard = () => {
  return (
    <a className="search-result-link">
      <div className={"search-result-card-loading"}>
        <div className="search-result-avatar">
          <Skeleton style={{ height: 135, width: 135, marginRight: 40 }} />
        </div>

        <div className="search-result-card-content-loading">
          <div className="search-result-metadata">
            <span className="search-result-shortname-loading">
              <Skeleton />
            </span>
          </div>
          <div className="search-result-title-loading">
            <span className="title">
              <Skeleton />
            </span>
          </div>
          <div className="search-result-desc small-text">
            <Skeleton />
          </div>
        </div>
      </div>
    </a>
  );
};

export default SearchResultSkeletonCard;
